export const PlusTrans = ({
  className,
  style,
  color = 'black',
}: {
  className?: string;
  style?: Record<string, unknown>;
  color?: string;
}) => {
  return (
    <svg
      className={className}
      style={style}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="8"
        cy="8"
        r="7.5"
        transform="rotate(180 8 8)"
        stroke={color}
      />
      <path
        d="M7.66981 11.1705C7.66978 11.3904 7.86281 11.5879 8.0917 11.5879C8.32286 11.5856 8.51586 11.3882 8.51586 11.1727L8.51586 8.51556L11.1686 8.51556C11.393 8.51552 11.586 8.32252 11.586 8.09363C11.5837 7.86247 11.393 7.67173 11.1686 7.67169H8.51586L8.51363 5.01676C8.5136 4.79236 8.32286 4.59709 8.0917 4.59935C7.86281 4.59935 7.66981 4.79236 7.66981 5.01679L7.66977 7.66947L5.01487 7.67173C4.79715 7.66947 4.59517 7.86247 4.59743 8.09363C4.59742 8.32252 4.79716 8.51777 5.01487 8.51552L7.66977 8.51778L7.66981 11.1705Z"
        fill={color}
      />
    </svg>
  );
};

